import BaseApi from 'api/core/baseApi';
import fetchAllPages from 'api/core/fetchAllPages';
import { ENDPOINTS } from 'api/config/endpoints';

class PutAwayApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PUT_AWAY);
  }

  completePutaway(putawayId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${putawayId}/complete/`,
      {},
    );
  }

  getPutawayGRNLines(putawayId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${putawayId}/grn-lines/?${queryString}`
      : `${this.getResourceUrl()}${putawayId}/grn-lines/`;

    return this.httpClient.get(url);
  }

  getAllPutawayGRNLines(putawayId) {
    return fetchAllPages(params => this.getPutawayGRNLines(putawayId, params));
  }

  exportPutaway(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new PutAwayApi();
